import { DialogTemplate } from "@fluentui/web-components";
import { styles as DialogStyles } from "./dialog.styles.js";
import { DesignSystem } from "../design-system.js";
import { Dialog } from "./dialog.js";
/**
 * The Fabric Dialog component.
 *
 * @public
 */
export const definition = Dialog.compose({
    name: `${DesignSystem.prefix}-dialog`,
    template: DialogTemplate,
    styles: DialogStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=dialog.definition.js.map